<template>
  <svg class="mx-auto divider-line" :height="height" width="50">
    <line x1="10" y1="0" x2="200" y2="0" />
  </svg>
</template>

<script>
export default {
  name: "dividerLine",
  props: {
    height: {
      type: [String, Number],
      default: 10
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/Style/utils/variables.scss';

svg {
  display: block;
}

.divider-line line {
  stroke: $tertiary;
  stroke-width: 4;
}
</style>
